import { render, staticRenderFns } from "./ListDappConnectionView.vue?vue&type=template&id=392b333e"
import script from "./ListDappConnectionView.vue?vue&type=script&lang=ts"
export * from "./ListDappConnectionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports